import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';

const AdminProtected = ({ children }) => {
  const { isAuthenticated, loading } = useAdminAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="admin-protected-loading">
        <div className="admin-protected-spinner" />
        <p>Loading...</p>
        <style>{`
          .admin-protected-loading {
            display: flex; flex-direction: column; align-items: center;
            justify-content: center; height: 100vh; gap: 16px;
            background: var(--admin-bg, #f4f4f4); font-family: var(--admin-font, inherit);
          }
          .admin-protected-spinner {
            width: 40px; height: 40px;
            border: 3px solid #e8e8e8; border-top-color: #1a1e18;
            border-radius: 50%; animation: protSpin 0.7s linear infinite;
          }
          .admin-protected-loading p {
            color: #a0a0a0; font-size: 14px; margin: 0;
          }
          @keyframes protSpin { to { transform: rotate(360deg); } }
        `}</style>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default AdminProtected;